import React from 'react';
import _ from 'lodash';

import { Menu, Dropdown } from 'antd';

const DropdownButton = (props) => {
   const menu = (
      <Menu onClick={props.action}>
         {
            props.values.map((value) => {
               return <Menu.Item key={value.id}>{value.name}</Menu.Item>
            })
         }
      </Menu>
   );

   return (
      <Dropdown.Button
         size={props.size ? props.size : 'middle'}
         type={props.type ? props.type : 'primary'}
         overlay={menu}
         buttonsRender={([leftButton, rightButton]) => [
            React.cloneElement(leftButton, { className: 'fake-button' }),
            React.cloneElement(rightButton, { loading: props.loading }),
         ]}
      >
         {props.title}
      </Dropdown.Button>
   )
}

export default DropdownButton;